module.exports = __webpack_public_path__ + "img/lre0005jp01.78d31244.jpg";